import { formatMarketingSites } from '@/temu-platform/utils/temuMarketingDisplay';

/**
 * 营销列表「站点」列：全站 ALL；部分站点截断展示，title 为全量。
 */
export default function MarketingSitesCell({ row, maxVisible = 4, className = '' }) {
  const { label, title } = formatMarketingSites(row, { maxVisible });
  return (
    <span className={className || undefined} title={title}>
      {label}
    </span>
  );
}
